import React from 'react';
import { Target, Eye, MapPin } from 'lucide-react';

const QuemSomos = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="py-20 text-white" style={{ backgroundColor: '#1E3A8A' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-6xl font-bold mb-8">QUEM SOMOS NÓS?</h1>
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="text-lg leading-relaxed mb-6">
                Seus fundadores, Lucas Coradin e Rodrigo de Souza, vieram da região Sul com um firme propósito, fazendo nascer assim, no Cone Sul de Rondônia, um novo modelo de distribuição de insumos agrícolas, visando gerar oportunidades para o homem do campo e trazendo tecnologia e inovação por meio de uma linha de produtos de altíssima qualidade.
              </p>
              <p className="text-lg leading-relaxed mb-6">
                Nossa matriz, sediada em Vilhena (RO), é a porta de entrada do nosso estado e, junto dela, temos filiais em pontos estratégicos para atender aos nossos parceiros comerciais com o máximo de proximidade e dedicação. Dispomos, inclusive, de uma filial na região do Vale do Guaporé, no município de Pontes e Lacerda, no estado de Mato Grosso.
              </p>
              <p className="text-lg leading-relaxed">
                O Grupo Sodin conta com apoio logístico eficiente, prestando serviços de comercialização de insumos agrícolas, sempre buscando maximizar os resultados de produtividade dos nossos clientes e fortalecendo cada vez mais a parceria ao longo dos anos.
              </p>
            </div>
            <div className="flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/n98a3kpz_WhatsApp%20Image%202026-05-27%20at%2011.28.13.png"
                alt="Matriz Cultivar Agrícola - Vilhena"
                className="rounded-lg shadow-2xl w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Missão e Visão */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Missão */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="bg-green-600 p-3 rounded-full">
                  <Target className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-green-600 ml-4">MISSÃO</h2>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                Oferecer ao mercado insumos produtos agrícolas de aplicando conceitos e alta qualidade, modernos de negociações, comercialização e logística de entregas, a partir de processos eficientes, inovadores e integrados.
              </p>
              <div
                className="mt-6 h-48 rounded-lg bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://customer-assets.emergentagent.com/job_8b43b00b-d49b-410d-b712-afa38bbd140c/artifacts/gpyiju08_10-vantagens-de-trazer-novas-tecnologias-para-a-fazenda-Portal-Agrigent-1024x576.jpg)',
                }}
              ></div>
            </div>

            {/* Visão */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="bg-blue-600 p-3 rounded-full">
                  <Eye className="w-8 h-8 text-white" />
                </div>
                <h2 className="text-3xl font-bold text-blue-600 ml-4">VISÃO</h2>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                Tornar-se referência no Estado de Rondônia como um dos principais fornecedores de insumos e produtos agrícolas, bem como, oferecer serviços de logística de alta qualidade, gerando valor e relações sustentáveis com nossos clientes.
              </p>
              <div className="mt-6 grid grid-cols-2 gap-4">
                <div
                  className="h-32 rounded-lg bg-cover bg-center"
                  style={{
                    backgroundImage: 'url(https://customer-assets.emergentagent.com/job_8b43b00b-d49b-410d-b712-afa38bbd140c/artifacts/dtdtc8yc_IMG_3779.JPG)',
                  }}
                ></div>
                <div
                  className="h-32 rounded-lg bg-cover bg-center"
                  style={{
                    backgroundImage: 'url(https://customer-assets.emergentagent.com/job_8b43b00b-d49b-410d-b712-afa38bbd140c/artifacts/vhdpi622_images%20%283%29.jpg)',
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Localização */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <MapPin className="w-12 h-12 text-green-600" />
            </div>
            <h2 className="text-4xl font-bold text-gray-800">Nossa Presença</h2>
            <p className="text-gray-600 mt-4 text-lg">Estamos presentes em 6 unidades em RO e MT</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Matriz Vilhena */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden ring-4 ring-green-600">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jtbzkk4m_ChatGPT%20Image%2025%20de%20jun.%20de%202026%2C%2016_02_00.png"
                  alt="Matriz Vilhena"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                  MATRIZ
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">Vilhena - RO</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Av. Jô Sato, 1953</p>
                    <p>Novo Tempo, Vilhena - RO</p>
                    <p>CEP 76982-131</p>
                  </div>
                </div>
                <a
                  href="https://maps.app.goo.gl/hgTRX248WvQJjyaLA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5569996010407"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-2"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>

            {/* Cacoal */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/urnlwo1g_cacoal%202026.jpg"
                  alt="Cacoal"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  FILIAL
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">Cacoal - RO</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Av. Castelo Branco, 18592</p>
                    <p>Princesa Isabel, Cacoal - RO</p>
                    <p>CEP 76964-012</p>
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Av+Castelo+Branco+18592+Cacoal+RO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="mailto:gerencia.cacoal@cultivaragricola.com"
                  className="block text-center bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm font-semibold mt-2 break-all"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>

            {/* Pontes e Lacerda */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e2qbu7le_14%20i.jpg"
                  alt="Pontes e Lacerda"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  FILIAL
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">Pontes e Lacerda - MT</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Av. Valdemar Bittencourt, 290B</p>
                    <p>Jardim Bela Vista 3, Pontes e Lacerda - MT</p>
                    <p>CEP 78250-000</p>
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Av+Valdemar+Bittencourt+290B+Jardim+Bela+Vista+Pontes+e+Lacerda+MT"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5565996008340"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-2"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>

            {/* São Miguel do Guaporé */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/jg8avp20_smg%202026.jpg"
                  alt="São Miguel do Guaporé"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  FILIAL
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">São Miguel do Guaporé - RO</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>R. Luiz Lobato, 30</p>
                    <p>Liberdade, São Miguel do Guaporé - RO</p>
                    <p>CEP 76932-000</p>
                    <p>CEP 76932-000</p>
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Av+Aluizio+Pinheiro+610+Liberdade+Sao+Miguel+do+Guapore+RO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5569984474778"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-2"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>

            {/* Ariquemes */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/e1je7ftn_12%20i.jpg"
                  alt="Ariquemes"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  FILIAL
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">Ariquemes - RO</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>BR-364, 3839</p>
                    <p>Marechal Dutra, Ariquemes - RO</p>
                    <p>CEP 76877-225</p>
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=BR+364+3839+Ariquemes+RO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5569984617269"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-2"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>

            {/* Cerejeiras */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow">
              <div className="relative h-48">
                <img
                  src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/ui9bnqne_11%20i.jpg"
                  alt="Cerejeiras"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  FILIAL
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 text-center">Cerejeiras - RO</h3>
                <div className="flex items-start space-x-2 text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p>Av. das Nações, 3369</p>
                    <p>Maranata, Cerejeiras - RO</p>
                    <p>CEP 76997-000</p>
                  </div>
                </div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Cultivar+Agricola+Cerejeiras+RO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-3"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5569993751423"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-center bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-semibold mt-2"
                >
                  Falar com Gerente
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuemSomos;